import { useState, useEffect } from "react";
import { Coins, TrendingUp, Target, Zap, Trophy } from "lucide-react";
import api from "../../services/api";
import BrokerDoletasGoal from "./BrokerDoletasGoal";
import BrokerDoletasSources from "./BrokerDoletasSources";

function fmt(n) { return n == null ? "0" : n.toLocaleString("pt-BR"); }
function fmtR(v) { return v == null ? "R$ 0" : "R$ " + v.toLocaleString("pt-BR", { minimumFractionDigits: 2 }); }

export default function BrokerDoletasWidget() {
  var _s = useState(null);
  var data = _s[0];
  var setData = _s[1];

  useEffect(function () {
    async function load() {
      try {
        var res = await api.get("/doletas/broker-dashboard");
        setData(res.data);
      } catch (e) {}
    }
    load();
  }, []);

  if (!data || !data.enabled) return null;

  var specialtyLabel = data.specialty === "consorcio" || data.specialty === "consorcios" ? "Consorcios"
    : data.specialty === "seguro" || data.specialty === "seguros" ? "Seguros"
    : data.specialty === "plano_saude" ? "Plano de Saude" : data.specialty || "Geral";

  return (
    <div className="bg-gradient-to-br from-[#0A2F3D] to-[#163d4f] rounded-xl lg:rounded-2xl p-5 lg:p-6 shadow-sm mb-6 lg:mb-8 text-white" data-testid="broker-doletas-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Coins className="w-5 h-5 text-amber-400" />
          <h3 className="text-sm lg:text-base font-bold">Minhas DOLETAS</h3>
        </div>
        <span className="px-2 py-1 text-[10px] font-medium bg-white/15 rounded-full">{specialtyLabel}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <Coins className="w-4 h-4 mx-auto mb-1 text-amber-400" />
          <p className="text-xl font-bold" data-testid="broker-doletas-balance">{fmt(data.balance)}</p>
          <p className="text-[10px] text-white/50">Saldo</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <TrendingUp className="w-4 h-4 mx-auto mb-1 text-emerald-400" />
          <p className="text-xl font-bold">{fmtR(data.balance_reais)}</p>
          <p className="text-[10px] text-white/50">Valor R$</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <Zap className="w-4 h-4 mx-auto mb-1 text-blue-400" />
          <p className="text-xl font-bold">x{data.seller_cross_multiplier}</p>
          <p className="text-[10px] text-white/50">Cross</p>
        </div>
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center">
          <Target className="w-4 h-4 mx-auto mb-1 text-rose-400" />
          <p className="text-xl font-bold">x{data.seller_own_multiplier}</p>
          <p className="text-[10px] text-white/50">Proprio</p>
        </div>
      </div>
      <BrokerDoletasGoal balance={data.balance} goal={data.annual_goal} progress={data.goal_progress_pct} />
      <BrokerDoletasSources sources={data.sources_data} totalEarned={data.total_earned} />
    </div>
  );
}
